import { render, staticRenderFns } from "./join.vue?vue&type=template&id=9ddc04de&scoped=true"
import script from "./join.vue?vue&type=script&lang=js"
export * from "./join.vue?vue&type=script&lang=js"
import style0 from "./join.vue?vue&type=style&index=0&id=9ddc04de&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddc04de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ddc04de')) {
      api.createRecord('9ddc04de', component.options)
    } else {
      api.reload('9ddc04de', component.options)
    }
    module.hot.accept("./join.vue?vue&type=template&id=9ddc04de&scoped=true", function () {
      api.rerender('9ddc04de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/users/competition/join.vue"
export default component.exports